import React, { useState } from 'react';
import { PageHero } from '../components/layout/PageHero';
import { BidCard } from '../components/bids/BidCard';
import { BidFilters } from '../components/bids/BidFilters';
import { bids, getEffectiveStatus } from '../data/bids';
export function Bids() {
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [categoryFilter, setCategoryFilter] = useState('All Categories');
  const statusOrder: Record<string, number> = {
    'closing-soon': 0,
    open: 1,
    closed: 2
  };
  const filteredBids = bids.filter(bid => {
    const effectiveStatus = getEffectiveStatus(bid);
    const matchesSearch = bid.title.toLowerCase().includes(searchQuery.toLowerCase()) || bid.description.toLowerCase().includes(searchQuery.toLowerCase()) || bid.reference.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = statusFilter === 'all' || effectiveStatus === statusFilter;
    const matchesCategory = categoryFilter === 'All Categories' || bid.category === categoryFilter;
    return matchesSearch && matchesStatus && matchesCategory;
  }).sort((a, b) => statusOrder[getEffectiveStatus(a)] - statusOrder[getEffectiveStatus(b)]);
  return <div data-id="element-663">
      <PageHero title="Bids & Tenders" subtitle="Explore current procurement opportunities and submit your proposals" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Bids & Tenders'
    }]} data-id="element-664" />

      <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-665">
        <BidFilters searchQuery={searchQuery} setSearchQuery={setSearchQuery} statusFilter={statusFilter} setStatusFilter={setStatusFilter} categoryFilter={categoryFilter} setCategoryFilter={setCategoryFilter} data-id="element-666" />

        <div className="mb-6" data-id="element-667">
          <p className="text-gray-600" data-id="element-668">
            Showing{' '}
            <span className="font-bold text-charcoal" data-id="element-669">
              {filteredBids.length}
            </span>{' '}
            bid{filteredBids.length !== 1 ? 's' : ''}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-670">
          {filteredBids.map((bid, index) => <BidCard key={bid.id} bid={bid} index={index} data-id="element-671" />)}
        </div>

        {filteredBids.length === 0 && <div className="text-center py-12" data-id="element-672">
            <p className="text-gray-600 text-lg" data-id="element-673">
              No bids found matching your criteria.
            </p>
          </div>}
      </div>
    </div>;
}